/* eslint-disable @typescript-eslint/no-unused-vars */
import { ImageList } from '@mui/material';
import { Gallery } from 'react-photoswipe-gallery';

import type { Incident } from '../../../../types';
import getPhotoFormats from '../../../../utils/getPhotoFormats';
import { useFullScreen } from '../../../FullScreen';
import ImageItem from '../../../IncidentTable/components/renderer/PhotosRenderer/components/ImageItem';
import { IMAGE_SIZE, MAX_IMAGE_INDEX } from '../../../IncidentTable/components/renderer/PhotosRenderer/constants';

const PhotosRenderer = (photos: Incident['photos']) => {
  const images = (photos ?? []).map((photo) => getPhotoFormats(photo));
  const { ref } = useFullScreen();
  return (
    <Gallery
      options={{
        appendToEl: ref.current ?? undefined,
      }}
    >
      <ImageList sx={{ maxHeight: 300 }} cols={2} rowHeight={IMAGE_SIZE}>
        {images.map(({ thumbnailSizeImage, originalSizeImage }, index) => (
          <ImageItem
            key={thumbnailSizeImage.url}
            thumbnailImage={thumbnailSizeImage}
            originalImage={originalSizeImage}
            index={index}
            maxImageIndex={MAX_IMAGE_INDEX}
          />
        ))}
      </ImageList>
    </Gallery>
  );
};

export default PhotosRenderer;
